import {
  getPage,
  getDetail,
  getClientPage,
  datespeedlimit,
  datevehicleInfoGroupspeedlimit,
} from '@/api/overspeedanalysisregulationserv'

export default {
  state: {
    state_OverspeedAnalysisRegulation_GetPageResult: null,
    state_OverspeedAnalysisRegulation_GetDetailResult: null,
    state_OverspeedAnalysisRegulation_GetClientPageResult: null,
    state_OverspeedAnalysisRegulation_DatespeedlimitResult: null,
    state_OverspeedAnalysisRegulation_DatevehicleInfoGroupspeedlimitResult: null,
  },
  mutations: {
    SET_OVERSPEEDANALYSISREGULATION_GETPAGE_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisRegulation_GetPageResult = rst;
    },
    SET_OVERSPEEDANALYSISREGULATION_GETDETAIL_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisRegulation_GetDetailResult = rst;
    },
    SET_OVERSPEEDANALYSISREGULATION_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisRegulation_GetClientPageResult = rst;
    },
    SET_OVERSPEEDANALYSISREGULATION_DATESPEEDLIMIT_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisRegulation_DatespeedlimitResult = rst;
    },
    SET_OVERSPEEDANALYSISREGULATION_DATEVEHICLEINFOGROUPSPEEDLIMIT_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisRegulation_DatevehicleInfoGroupspeedlimitResult = rst;
    },
  },
  actions: {
    OverspeedAnalysisRegulationServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISREGULATION_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISREGULATION_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OverspeedAnalysisRegulationServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISREGULATION_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISREGULATION_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OverspeedAnalysisRegulationServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OverspeedAnalysisRegulationServ_Datespeedlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datespeedlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISREGULATION_DATESPEEDLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISREGULATION_DATESPEEDLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OverspeedAnalysisRegulationServ_DatevehicleInfoGroupspeedlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datevehicleInfoGroupspeedlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISREGULATION_DATEVEHICLEINFOGROUPSPEEDLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISREGULATION_DATEVEHICLEINFOGROUPSPEEDLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_OverspeedAnalysisRegulation_GetPageResult: state => {
      return state.state_OverspeedAnalysisRegulation_GetPageResult;
    },
    get_OverspeedAnalysisRegulation_GetDetailResult: state => {
      return state.state_OverspeedAnalysisRegulation_GetDetailResult;
    },
    get_OverspeedAnalysisRegulation_GetClientPageResult: state => {
      return state.state_OverspeedAnalysisRegulation_GetClientPageResult;
    },
    get_OverspeedAnalysisRegulation_DatespeedlimitResult: state => {
      return state.state_OverspeedAnalysisRegulation_DatespeedlimitResult;
    },
    get_OverspeedAnalysisRegulation_DatevehicleInfoGroupspeedlimitResult: state => {
      return state.state_OverspeedAnalysisRegulation_DatevehicleInfoGroupspeedlimitResult;
    },
  }
}